import Network from '@/Network'
import { AuthorizationResourcesAndSubjects, AuthorizationRelations } from '@/types/authorization'
import { UpsertPermissionsRequest } from '@/Network/Types/Requests/AuthorizationRequests'
import { ModuleTypeStrategy, PermissionOption } from './ModuleTypeStrategy'

const PERMISSIONS_FOR_NEW_USERS: PermissionOption[] = [
  { label: 'Analista de Documentação', value: AuthorizationRelations.DocumentationAnalyst },
  { label: 'Analista Financeiro', value: AuthorizationRelations.FinancialAnalyst }
]

const PERMISSIONS_FOR_SELECT: PermissionOption[] = [
  { label: 'Proprietário', value: AuthorizationRelations.Parent, disabled: true },
  { label: 'Analista de Documentação', value: AuthorizationRelations.DocumentationAnalyst },
  { label: 'Analista Financeiro', value: AuthorizationRelations.FinancialAnalyst }
]

export class PostStationStrategy implements ModuleTypeStrategy {
  getPermissionsForNewUsers(): PermissionOption[] {
    return PERMISSIONS_FOR_NEW_USERS
  }

  getPermissionsForSelect(): PermissionOption[] {
    return PERMISSIONS_FOR_SELECT
  }

  getDefaultPermission(): AuthorizationRelations {
    return AuthorizationRelations.DocumentationAnalyst
  }

  resolveResourceType(base: AuthorizationResourcesAndSubjects): AuthorizationResourcesAndSubjects {
    if (base === AuthorizationResourcesAndSubjects.Company)
      return AuthorizationResourcesAndSubjects.PostStationCompany
    if (base === AuthorizationResourcesAndSubjects.HealthUnit)
      return AuthorizationResourcesAndSubjects.PostStationHealthUnit
    return AuthorizationResourcesAndSubjects.PostStationCompany
  }

  async addPermissions(
    resourceId: number,
    companyId: number,
    payload: UpsertPermissionsRequest,
    resourceType: AuthorizationResourcesAndSubjects
  ): Promise<void> {
    switch (resourceType) {
      case AuthorizationResourcesAndSubjects.PostStationCompany:
        await Network.permission.addPostStationCompanyPermissions(resourceId, payload)
        break
      case AuthorizationResourcesAndSubjects.PostStationHealthUnit:
        await Network.permission.addPostStationHealthUnitPermissions(resourceId, companyId, payload)
        break
    }
  }

  async upsertPermissions(
    resourceId: number,
    companyId: number,
    payload: UpsertPermissionsRequest,
    resourceType: AuthorizationResourcesAndSubjects
  ): Promise<void> {
    switch (resourceType) {
      case AuthorizationResourcesAndSubjects.PostStationCompany:
        await Network.permission.upsertPostStationCompanyPermissions(resourceId, payload)
        break
      case AuthorizationResourcesAndSubjects.PostStationHealthUnit:
        await Network.permission.upsertPostStationHealthUnitPermissions(
          resourceId,
          companyId,
          payload
        )
        break
    }
  }
}
